// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"ebbf66c9","213":"1c7c7475","239":"4dda6de1","316":"2c423021","358":"8d3cc410","419":"b4a6bc65","455":"fe6c1a76","558":"2da16cfc","583":"85975e4f","691":"2dee1ddc","796":"43af0486","836":"f4235931","859":"40008d85"}[chunkId] + ".chunk.js";
};